
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/locale-switcher",
      function () {
        return require("private-next-pages/locale-switcher.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/locale-switcher"])
      });
    }
  